import React, { useContext, useState } from 'react';

import { Modules } from 'scbk-services/config';
import _ from 'scbk-services/utils/lodash-extension.ts';

interface HostModuleContextType {
    hostModule: Modules;
    setHostModule: (module: Modules) => void;
}

interface HostModuleProviderProps {
    children: React.ReactNode;
}

const HostModuleContext = React.createContext<HostModuleContextType | undefined>(undefined);

export const HostModuleProvider: React.FC<HostModuleProviderProps> = ({ children }) => {
    const [hostModule, setHostModule] = useState<Modules>(Modules.EMPTY);

    console.log('Current Host Module:', hostModule);

    return (
        <HostModuleContext.Provider value={{ hostModule, setHostModule }}>
            {children}
        </HostModuleContext.Provider>
    );
};

export const useHostModule = () => {
    const context = useContext(HostModuleContext);

    if (_.isEmpty(context)) {
        throw new Error('useHostModule must be used within a HostModuleProvider');
    }

    return context;
};
